import NoLogInPageWeb from 'components/layout/NoLogOutPageWeb';
import styled       from '@emotion/styled';
import { useAtom }  from "jotai";
import Checkbox from './Checkbox';
import Balloon  from 'components/ui/Balloon';
import { useNavigate } from 'react-router-dom';
import { Button, ContextContainer,RadioButton}       from "components/ui";
import { checkedBoxesAtom, SelectedRadiobuttonAtom } from "components/pages/Onboarding/onboardingAtom";
import ReactGA from "react-ga4";
import { useEffect } from 'react';


const Elem:React.FC<any> = () => {
  const [ selectedOption, setSelectedOption ] = useAtom(SelectedRadiobuttonAtom);
  const [ checkboxes, setCheckboxes ] = useAtom(checkedBoxesAtom);
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const navigator = useNavigate();

  //전체 체크박스를 클릭하는 함수
  const handleAllCheckboxChange = (e:any) => {
    const { checked } = e.target;
    setCheckboxes({
      termsCondition : checked,
      personalInformation : checked,
      marketingConstent : checked
    });
  };

  // 개별 체크박스를 클릭하는 함수
  const handleCheckboxChange = (event:any) => {
    const { name, checked } = event.target;
    setCheckboxes(prevCheckboxes => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const handleOptionChange = (e:any) => {
    setSelectedOption(e.target.value);
  }

  interface Ga4Param{
    category:string;
    action : string;
    label: string;
    companyId:number
  }

  let ga4Params:Ga4Param;
  const handleCardRegistration = (e:any) => {
    if (selectedOption === 'option1') {
      navigator("/registration/kakao")
      ga4Params = {
        "category": "Button",
        "action" : "Click",
        "label" : "pay descripntion upload Button",
        "companyId" : 2
      }

      ReactGA.event(ga4Params)
    } else if (selectedOption === 'option2') {
      navigator("/registration/payple");

      ga4Params = {
        "category": "Button",
        "action" : "Click",
        "label" : "pay descripntion upload Button",
        "companyId" : 1
      }

      ReactGA.event(ga4Params)
    }
  }; 

  useEffect (() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/onboarding/4/credit", title: "pay description view" })
    }
  },[])
  
  return (
    <NoLogInPageWeb disable={false}>
      <Container>
        <Body>
          <TextContainer>
            <SmallText className="first"><span>3/3</span>단계</SmallText>
            <BigText className="Top">결제방법을 선택하세요</BigText>
            <SmallText className="small">25일 첫 결제되고 지금은 등록만 진행돼요.</SmallText>
            <SmallText className="small">부담없이 무료체험 하세요.</SmallText>
          </TextContainer>
          <FirstContainer>
            <SmallText className="title">결제 예정 금액</SmallText>
            <Context className="context">
              <ContextWrapper className="Title">매달 25일</ContextWrapper>
              <ContextWrapper className="contents">8,900원</ContextWrapper>
            </Context>
          </FirstContainer>
          <SecondContainer>
            <SmallText className="title">결제 수단</SmallText>
            <RadioContainer>
              <Context className="radio">
                <PayRadioButton
                type="radio"
                name="kakao"
                value="option1"
                checked={selectedOption === 'option1'}
                onChange={handleOptionChange}
              >
                <span>카카오페이</span>
              </PayRadioButton>
              </Context>
              <Context className="radio">
                <PayRadioButton
                  type="radio"
                  name="papple"
                  value="option2"
                  checked={selectedOption === 'option2'}
                  onChange={handleOptionChange}
                >
                  <span>신용카드 또는 체크카드</span>
                </PayRadioButton>
              </Context>
            </RadioContainer>
          </SecondContainer>
          <CheckedContainer>
            <SmallText className="title">이용약관</SmallText>
            <CheckBoxContainer>
              <Context className="context">
                <AgreeCheckBox
                  name="checkbox1"
                  checked={checkboxes.termsCondition && checkboxes.personalInformation && checkboxes.marketingConstent}
                  onChange={handleAllCheckboxChange}
                  className="subCheck"
                ><span>이용약관에 모두 동의합니다.</span></AgreeCheckBox>
              </Context>
              <SubCheckWrapper>
                <AgreeCheckBox
                  name="termsCondition"
                  checked={checkboxes.termsCondition}
                  onChange={handleCheckboxChange}
                  className="subCheck"
                ><span>[필수] 포티페타 이용약관</span></AgreeCheckBox>
              </SubCheckWrapper>
              <SubCheckWrapper>
                <AgreeCheckBox
                  name="personalInformation"
                  checked={checkboxes.personalInformation}
                  onChange={handleCheckboxChange}
                  className="subCheck"
                ><span>[필수] 개인정보 수집 이용 동의</span></AgreeCheckBox>
              </SubCheckWrapper>
              <SubCheckWrapper>
                <AgreeCheckBox
                  name="marketingConstent"
                  checked={checkboxes.marketingConstent}
                  onChange={handleCheckboxChange}
                  className="subCheck"
                ><span>[선택] 마케팅 수신 동의</span></AgreeCheckBox>
              </SubCheckWrapper>
            </CheckBoxContainer>
          </CheckedContainer>
          <BolleanContainer>
            <Balloon>
              <BalloonText className="top">등록 완료 하시면</BalloonText>
              <BalloonText className="bottom"><ChangeBoldText>무료체험</ChangeBoldText>이 자동으로 신청됩니다.</BalloonText>
            </Balloon>
          </BolleanContainer>
          <ButtonContainer>
            <SubmitButton
              layoutVariant="contained"
              variant="default"
              expand
              isActive={!!(
                checkboxes.termsCondition === true && checkboxes.personalInformation === true
              )}
              onClick={handleCardRegistration}
            >결제 수단 등록
            </SubmitButton>
          </ButtonContainer>
        </Body>
      </Container>
    </NoLogInPageWeb>
  )
}

export default Elem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 24px 17px;
`;
const TextContainer = styled.div`
  width: 220px;
  height: 50px;
  display: flex;
  flex-direction: column;
  margin-left: -10px;
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 100%;
  color: #141414;

  span {
    font-weight: 700;
  }
  &.first {
    margin-bottom: 15px;
  }
  &.Second {
    margin-top: 12.37px;
  }
  &.title {
    font-weight: 500;
    font-size: 14px;
  }
  &.small {
    margin-top: 5px;
    color: rgba(117, 117, 117, 1);
  }
`;
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  line-height: 100%;
  color: #141414;

  &.Top {
    font-weight: Bold;
    /* margin-bottom: 5px; */
  }

  &.Bottom {
    font-weight: 300;
  }
`;
const FirstContainer = styled.div`
  width: 100%;
  height: 89px;
  margin-top: 67px ;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const Context = styled(ContextContainer)`
  height: 55px;
  display: flex;
  flex-direction: row;
  

  &.context {
    padding-top: 0;
    padding-left: 20px;
    justify-content: space-between;
  }

  &.radio {
    background-color: var(--light-grey);
    font-family: 'Pret endard';
    
    font-style: normal;
    font-weight: 400;
    color: var(--dark-grey);;
  }
  
  span {
    font-size: 15px;
    &.title{
      color:rgba(99, 99, 99, 1);
      font-family: 'Pretendard';
      font-style: normal;
      font-size: 13px;
      font-weight: 400;
      margin-top: 20px;
    }
    &.contents{
      margin-right: 23px;
      color: var(--black);
    }
    &.label {
      margin-left:14px;
      font-family: 'Pretendard';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 100%;
      color: #111111;
    }
  }
`
const SecondContainer = styled.div`
  width: 100%;
  height: 153px;
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const RadioContainer = styled.div`
height: 119px;
display: flex;
flex-direction: column;
justify-content: space-between;

span{
  margin-left:14px;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;

  color: #111111;
}
`
const CheckedContainer = styled.div`
  width: 100%;
  height: 185px;
  margin-top: 48px;
`
const CheckBoxContainer = styled.div`
  width: 100%;
  height: 153px;
  margin-top: 18px;
  display: flex;
  flex-direction: column;
`
const SubCheckWrapper = styled.div`
  width: 100%;
  height: 38.18px;
  padding-left: 25.14px;
  padding-top: 10px;

  span {
    margin-left: 5.89px;
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
  }
`;
const BolleanContainer = styled.div`
  margin: 18px auto 0;
  width: 284px;
  height: 72.5px;
  background-color: antiquewhite;
`
const ChangeBoldText = styled.span`
  font-weight: Bold;
`;
const ButtonContainer = styled.div`
  /* width: 300px; */
  height: 52px;
  background-color: aliceblue;
  margin: 20px auto 0;
`;
const AgreeCheckBox =styled(Checkbox)`
  /* padding-left: 10px; */
`;
const PayRadioButton =styled(RadioButton)`
`;
const ContextWrapper = styled.span`
  margin: auto 0;
`;
interface ButtonProps {
  isActive:boolean;
}
const SubmitButton = styled(Button)<ButtonProps>`
  border: 1px solid ${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)};
  color :${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)};
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
`;
const BalloonText = styled.p`
  font-size: 13px;
  &.top{
    padding-top: 17px;
  }
  &.bottom{
    margin-top: -10px;
  }
`;
const Body = styled.div`
  width: 344px;
  margin: 40px auto;
`

